import { ControlConfig } from '../controlConfig';
import AddNewAttachment from './AddNewAttachment';
import ControlAttachmentEngine from './ControlAttachmentEngine';
import ControlAttachmentEntry from './ControlAttachmentEntry';
import ControlAttachmentPlaceholder from './ControlAttachmentPlaceholder';
import getLatestSchema from './schema';
import getYupSchemaForAttachmentEngine from './getYupSchemaForAttachmentEngine';
import translator from './translator';

export default {
  getDefaultValue: () => ({}),
  getLatestSchema,
  Engine: ControlAttachmentEngine,
  Entry: ControlAttachmentEntry,
  Add: AddNewAttachment,
  yupSchemaEngine: getYupSchemaForAttachmentEngine,
  yupSchemaEntry: () => ({}),
  translator,
  Placeholder: ControlAttachmentPlaceholder,
  hasAttachment: true,
  previewCardHeight: '120px'
} as ControlConfig;
